import { useState } from 'react';
import { useRouter } from 'next/router';
import Boto from 'components/3catinfo/Boto';
import Slider from 'components/3catinfo/Slider';
import clsx from 'clsx';
import styles from './llistatTemes.module.scss';

const BotoLletra = (props) => {
    const { lletra, selectLletra, setSelectLletra } = props;
    const router = useRouter();

    const stylesBotoLletra = clsx({
        [styles.botoLletra]: true,
        [styles.activa]: selectLletra === lletra
    });

    const goToLletra = () => {
        router.push(`#${lletra.toLowerCase()}`);
        setSelectLletra(lletra);
    };

    return <Boto className={stylesBotoLletra} tema='gris' tag='button' text={lletra} onClick={goToLletra} />;
};

const MenuLletres = (props) => {
    const { items } = props;
    const [selectLletra, setSelectLletra] = useState('#');

    return (
        <Slider tipus='menu' className={styles.menuLletres} estilFletxes='menuLletresFletxes'>
            {items.map((item, index) => (
                <BotoLletra
                    key={`llistat-temes-menu-lletres-lletra-${item.attributes.valor}-${index}`}
                    lletra={item.attributes.valor}
                    selectLletra={selectLletra}
                    setSelectLletra={setSelectLletra}
                />
            ))}
        </Slider>
    );
};

const LlistatTemesLletres = (props) => {
    const { items } = props;

    return (
        <>
            <MenuLletres items={items} />
        </>
    );
};

export default LlistatTemesLletres;
